import { Pipe, PipeTransform } from '@angular/core';
declare let iNet: any;
@Pipe({
  name: 'ssoUrl'
})
export class SSOUrlPipe implements PipeTransform {

  transform(url: string): string {
    return iNet.getSSOUrl(url);
  }

}
